class RedirectHandler {
  linkChain = [];

  setLinks = (link) => {
    if (Array.isArray(link)) {
      this.linkChain = this.linkChain.concat(link);
    } else {
      this.linkChain.push(link);
    }
  };

  getNextLink = () => {
    if (this.linkChain.length !== 0) {
      let nextLink = this.linkChain.shift();
      return nextLink;
    } else {
      return '';
    }
  };

  clear = () => {
    this.linkChain = [];
  };
}

export default new RedirectHandler();
